// The same art the apps ship. Only the URLs are bundled; each SVG loads when an avatar shows it.
const AVATAR_URLS = import.meta.glob('../assets/avatars/*/*.svg', { as: 'url', eager: true });

/**
 * `avatarIdx` is the file name: 0–199 are `adventurer-{idx}.svg`, 1000–1199 `creature-{idx}.svg`.
 * Anything else is invalid and gets `undefined`.
 */
export const getAvatarUrl = (avatarIdx?: number | null): string | undefined => {
  if (avatarIdx === null || avatarIdx === undefined) return undefined;
  const file = avatarIdx >= 1000 ? `creatures/creature-${avatarIdx}` : `adventurers/adventurer-${avatarIdx}`;
  return AVATAR_URLS[`../assets/avatars/${file}.svg`];
};

// The circle behind the avatar, by `avatarBackgroundIdx` (0–4): blue, coral, cream, green, yellow.
const AVATAR_BACKGROUNDS = ['#4D9ED1', '#E8A896', '#EDD9C2', '#8FBD78', '#E0BF4A'];

export const getAvatarBackground = (avatarBackgroundIdx?: number | null) =>
  AVATAR_BACKGROUNDS[avatarBackgroundIdx ?? 0] ?? AVATAR_BACKGROUNDS[0];
